import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class BrandManagementService {

  constructor(private _http: HttpClient) { }

  getbrands(data) {
    return this._http.post(environment.api_url+'master/brand/list',data);
  }

  deletebrand(data) {
    return this._http.post(environment.api_url+'master/brand/delete',data);
  }

}
